import React from "react"
import QuoteIcon from "../assets/QuoteIcon"

export interface Testinomial {
  name: string
  description: string
  content: string
  pic?: string
}

const Testimonial: React.FC<Testinomial> = ({
  name,
  description,
  content,
  pic,
}) => {
  return (
    <div className="testimonial-container">
      <div className="testimonial-content h3Text">
        <div
          style={{
            display: "flex",
            position: "absolute",
            left: "-50px",
          }}
        >
          <QuoteIcon />
        </div>
        {content}
        <div
          style={{
            display: "flex",
            position: "absolute",
            bottom: 0,
            right: "-50px",
          }}
        >
          <QuoteIcon isClosing />
        </div>
      </div>
      <div className="testimonial-user">
        <div
          className="testimonial-user-pic"
          style={{ background: pic ? `url(${pic})` : "#777" }}
        />
        <div className="testimonial-user-details">
          <div
            className="body-txt"
            style={{
              fontWeight: 700,
            }}
          >
            {name}
          </div>
          <div
            className="pText"
            style={{
              fontWeight: 400,
              opacity: "0.6",
              fontFamily: "LabilR",
            }}
          >
            {description}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Testimonial
